import api from '../../../data/api';
import { ProduceBanners } from './components/ProduceBanners';

const AddBanners = () => {
	const handleSubmit = async (bannerData) => {
		return await api.createBannerApi(bannerData);
	};

	return <ProduceBanners onSubmit={handleSubmit} />;
};

export default AddBanners;
